import { createStyles } from '@mantine/core';
import { getTypographyStyles } from 'src/theme/themeConfig';

export const useStyles = createStyles((theme) => {
  const { colors } = theme.other;
  return {
    container: {
      width: '100%',
      height: '100%',
      overflowY: 'auto',
      display: 'flex',
      flexDirection: 'column',
      backdropFilter: 'blur(34px)',
      overflow: 'hidden',
      backgroundColor: colors.bg.default,
    },
    header: {
      width: '100%',
      position: 'sticky',
      top: 0,
      padding: '16px',
      backdropFilter: 'blur(34px)',
      paddingBottom: '0px',
    },
    headerText: {
      fontWeight: 700,
      fontSize: '16px',
      lineHeight: '21px',
      padding: '1px 16px',
    },

    mobileInputWrapper: {
      position: 'relative',
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      fontWeight: 500,
      fontSize: '20px',
    // marginBottom: '16px'
    },
    mobileTextInputWrapper: {
      width: '100%',
      // marginTop: '-16px',
      marginBottom: '16px',
    },
    textInputWrapper: {
      width: '100%',
      marginBottom: '12px',
      marginTop: '12px',
    },
    inputLeftIcon: {
      position: 'absolute',
      left: 16,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '24px',
      width: '24px',
    },
    leftIconLight: {
      '& path': {
        fill: '#D9D9D9',
      },
    },
    mobileInput: {
      height: '45px',
      background: '#FFFFFF1A',
      border: '0.8px solid #959EB2',
      outlineColor: '#019DE6',
      outlineWidth: '1px',
      borderRadius: '8px',
      width: '100%',
      padding: '12px 24px 12px 56px',
      placeholderTextColor: '#959EB2',
      display: 'flex',
      alignItems: 'center',

    },
    selectedSearchTag: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      flexWrap: 'nowrap',
      padding: '4px 12px',
      gap: '6px',
      width: 'auto',
      borderRadius: '54px',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      backgroundColor: colors.primary.default,
      color: colors.base.white,
      ...getTypographyStyles('content_xs_medium'),

      '& p': {
        maxWidth: 'calc(100% - 28px)',
        overflow: 'hidden',
        marginRight: '10px',
      },
    },
    selectedSearchTagClose: {
      height: '16px',
      width: '16px',
      display: 'flex',
      alignItems: 'center',
      padding: 0,
      margin: 0,
      border: 'none',
      backgroundColor: 'transparent',
    },
    contentContainer: {
      padding: '1.25rem',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      paddingTop: '0',
    },
    allBankList: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
    },
    popularBankList: {
      display: 'flex',
      flexWrap: 'wrap',
      width: '100%',
      justifyContent: 'space-between',
      marginBottom: '16px',
    },
    popularBankSearchCard: {
      width: 'calc(50% - 4px)',
      borderRadius: '6px',
      marginBottom: '8px',
    },
    bankSearchCard: {
      display: 'flex',
      padding: '14px 12px',
      gap: '10px',
      alignItems: 'center',
      width: '100%',
      background: colors.bg.subtle,
      color: colors.fg.subtle,
      border: 'none',
      textAlign: 'left',
      cursor: 'pointer',
      ...getTypographyStyles('content_xs_medium'),
      ':hover': {
        background: colors.bg.muted,
      },
    },
    bankSearchCardIcon: {
      width: '24px',
      height: '24px',
    },
    bankSearchCardText: {
      fontWeight: 600,
      fontSize: '14px',
      lineHeight: '18px',
    },
    bankSearchCardSubtext: {
      marginTop: '2px',
      fontWeight: 400,
      fontSize: '10px',
      lineHeight: '14px',

    },
    selectBranchContainer: {
      display: 'flex',
      flexDirection: 'column',
      // padding: '12px 0',
      alignItems: 'center',
      width: '100%',
      border: 'none',
      textAlign: 'left',
    },
    transBack: {
      // background: '#ffffff4D',
    },
    solidInp: {
      background: '#ffffff',
      placeholderTextColor: '#BBBBBB',
      color: '#000000',
      padding: '12px 56px 12px 24px',
    },
    ifscSearchInput: {
      height: '45px',
      background: '#FFFFFF4D',
      border: '0.8px solid #959EB2',
      outlineColor: '#019DE6',
      outlineWidth: '1px',
      borderRadius: '8px',
      width: '100%',
      padding: '12px 24px 12px 56px',

      display: 'flex',
      alignItems: 'center',
      fontWeight: 400,
      fontSize: '16px',
      '&::placeholder': {
        color: '#BFBFBF',
      },
    },
    footer: {
      display: 'flex',
      justifyContent: 'flex-end',
      padding: '20px',
    },
    footerNew: {
      marginTop: 'auto',
      display: 'flex',
      justifyContent: 'flex-end',
      padding: '18px 20px',
      borderTop: `1px solid ${colors.disabled.subtle}`,
      width: '100%',
      paddingBottom: 0,
      minHeight: 72,
      [`@media (max-width: ${theme.breakpoints.xs})`]: {
        position: 'static',
        // paddingBottom: 0,
      },
    },
    heading: {
      marginBottom: '12px',
      ...getTypographyStyles('heading_xs_medium'),
    },
    headingAccNumber: {
      textAlign: 'left',
      marginTop: '10px',
      ...getTypographyStyles('heading_xs_medium'),
      width: '100%',
    },
    bankCategory: {
      marginBottom: '8px',
      ...getTypographyStyles('content_2xs_regular'),
    },
    description: {
      fontWeight: 400,
      fontSize: '18px',
      lineHeight: '23px',
      color: '#BFBFBF',
      marginBottom: '45px',
    },
    acNumberInputDesc: {
      textAlign: 'left',
      width: '100%',
      marginLeft: '6px',
      ...getTypographyStyles('content_xs_regular'),
    },
    panInputWrapper: {
      width: '100%',
      fontWeight: 500,
      fontSize: '20px',
    },
    searchInput: {
      height: '45px',
      background: '#FFFFFF1A',
      border: '0.8px solid #959EB2',
      outlineColor: '#019DE6',
      outlineWidth: '1px',
      borderRadius: '8px',
      width: '100%',
      padding: '12px 24px',

    },
    inputDescription: {
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '18px',
      color: '#8C8C8C',
      marginTop: '8px',
    },
    inputLeft: {
      fontWeight: 500,
      fontSize: '16px',
    },
    inputError: {
      color: 'red',
      width: '100%',
    },
    changeNumberLink: {
      marginTop: 'auto',
      marginBottom: '20px',
      color: '#1DBBF0',
    },
    inputNextButton: {
      position: 'absolute',
      right: '8px',
      padding: '4px 12px 4px 12px',
      border: 'none',
      display: 'flex',
      height: 'calc(100%-8px)',
      justifyContent: 'center',
      alignItems: 'center',
      background: '#EB2F96',
      borderRadius: '8px',
    },
    isfcSearchbarInput: {
      '.mantine-TextInput-input': {
        textTransform: 'uppercase',
      },
    },
    mb14: {
      marginBottom: '14px',
    },
    mr10: {
      marginRight: '10px',
    },
    setCtaWrapper: {
      display: 'flex',
      backgroundColor: colors.primary.muted,
      padding: '1rem 1.5rem',
      borderRadius: '0.5rem',
    },
    mobileImage: {
      width: '6.25rem',
    },
    // penny drop
    setuFooter: {
      justifyContent: 'flex-start !important',
    },
    setuFlowButton: {
      all: 'unset',
      cursor: 'pointer',
      ...getTypographyStyles('content_sm_regular'),

      '&:hover': {
        color: colors.primary.default,
      },
    },
    setuFlowContent: {
      // background: 'red',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
    },
    qrCode: {
      height: '200px',
    },
    mobileViewWrapper: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      height: '100%',
    },
    openUpiImage: {
      width: '80%',
      margin: 'auto',
    },
    iphoneUpiButton: {
      height: "max-content",
      width: "6.25rem",
      padding: ".8rem 0",
      background: colors.base.white,
      border: `1px solid ${colors.disabled.subtle}`,
      borderRadius: '.5rem',
      ":active": {
        background: colors.bg.subtle,
      },
    },
  };
});

export default useStyles;
